"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ICadStateEnum = exports.ICad = exports.ClassicPlacerEventsEnum = exports.AfterInsertEnum = void 0;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var ICadStateEnum = null;
exports.ICadStateEnum = ICadStateEnum;
if (typeof SH_CadState !== 'undefined') {
  exports.ICadStateEnum = ICadStateEnum = SH_CadState;
} else {
  console.warn("You are using ICAD without a proper engine include. Take care");
}
var ClassicPlacerEventsEnum;
exports.ClassicPlacerEventsEnum = ClassicPlacerEventsEnum;
(function (ClassicPlacerEventsEnum) {
  ClassicPlacerEventsEnum[ClassicPlacerEventsEnum["NO_FREE_SLOT"] = 0] = "NO_FREE_SLOT";
  ClassicPlacerEventsEnum[ClassicPlacerEventsEnum["SELECT_SLOT"] = 1] = "SELECT_SLOT";
})(ClassicPlacerEventsEnum || (exports.ClassicPlacerEventsEnum = ClassicPlacerEventsEnum = {}));
var AfterInsertEnum;
exports.AfterInsertEnum = AfterInsertEnum;
(function (AfterInsertEnum) {
  AfterInsertEnum[AfterInsertEnum["NOTHING"] = 0] = "NOTHING";
  AfterInsertEnum[AfterInsertEnum["NOT_INSERTED"] = 1] = "NOT_INSERTED";
  AfterInsertEnum[AfterInsertEnum["RE_EVAL_OBJ"] = 2] = "RE_EVAL_OBJ";
})(AfterInsertEnum || (exports.AfterInsertEnum = AfterInsertEnum = {}));
var ICad = /*#__PURE__*/function () {
  function ICad() {
    var _this = this;
    (0, _classCallCheck2["default"])(this, ICad);
    this.sharedDataCallback = function (event, data, type) {
      if (event === SharedCallbackEnums.PUSH_UNDO_ACTION && type == 2) {
        _this.onUpdate("PUSH_UNDO_ACTION", data, type);
      } else if (!_this.lockedCallbacks) {
        if (type == 2) {
          switch (event) {
            case SharedCallbackEnums.CHANGED_ACTIVE_ROW:
              _this.onUpdate("CHANGED_ACTIVE_ROW", data, type);
              break;
            case SharedCallbackEnums.CHANGED_SELECTION_LIST:
              _this.onUpdate("CHANGED_SELECTION_LIST", data, type);
              break;
            case SharedCallbackEnums.SELECTED_PLACER_SLOT:
              _this.onUpdate("SELECTED_PLACER_SLOT", data, type);
              break;
            case SharedCallbackEnums.EXPORT_JSON_SCENE:
              _this.onUpdate("EXPORT_JSON_SCENE", data, type);
              break;
            case SharedCallbackEnums.MOVE_PLACER_SLOT:
              _this.onUpdate("MOVE_PLACER_SLOT", data, type);
              break;
            case SharedCallbackEnums.RE_EVAL_OBJ:
              _this.onUpdate("RE_EVAL_OBJ", data, type);
              break;
            case SharedCallbackEnums.DELETE_SELECTED_OBJECTS:
              _this.deleteSelectedBox2D3D();
              _this.onUpdate("DELETE_SELECTED_OBJECTS", data, type);
              break;
            case SharedCallbackEnums.ZOOM_WINDOW_STATE_CHANGE:
              _this.onUpdate("ZOOM_WINDOW_STATE_CHANGE", data, type);
              break;
            case SharedCallbackEnums.OPEN_QUOTES_POP:
              _this.onUpdate("OPEN_QUOTES_POP", data, type);
              break;
            case SharedCallbackEnums.CHANGED_QUOTES_STATUS:
              _this.onUpdate("CHANGED_QUOTES_STATUS", data, type);
              break;
            case SharedCallbackEnums.NO_PLACER_SELECTED:
              _this.onUpdate("NO_PLACER_SELECTED", data, type);
              break;
            case SharedCallbackEnums.DOWNLOAD_IMG:
              _this.onUpdate("DOWNLOAD_IMG", data, type);
              break;
            case SharedCallbackEnums.ASK_MAP2D_MEASUREPOP:
              _this.onUpdate("ASK_MAP2D_MEASUREPOP", data, type);
              break;
            case SharedCallbackEnums.INSERT_UNIVERSAL_PLACER:
              _this.onUpdate("INSERT_UNIVERSAL_PLACER", data, type);
              break;
            case SharedCallbackEnums.DXF_PICKED_DRAW:
              _this.onUpdate("DXF_PICKED_DRAW", data, type);
              break;
          }
        } else {
          _this.onUpdate(event, data, type);
        }
      }
    };
    this.state = null;
    this.callback = null;
    this.onAppCallback = null;
    this.lockedCallbacks = false;
    this.sharedData = new SharedData();
    var x = this;
    this.sharedData.registerIcadCallback(function (event, data, type) {
      x.sharedDataCallback(event, data, type);
    });
  }
  (0, _createClass2["default"])(ICad, [{
    key: "init",
    value: function init(configJson, callback, project, noAntialias) {
      this.setCallback(callback);
      this.setCad2D(new WE_Cad(configJson.backsite, configJson.config, this.getSharedData()));
      this.set3D(new CadEngine(this.getSharedData()));
      this.get3D().initCadGhostEngine(configJson.backsite, configJson.config, this.sharedDataCallback, noAntialias);
      this.getCadWrapper().setProject(project);
    }
  }, {
    key: "createQuoteEngineViewMaker",
    value: function createQuoteEngineViewMaker(canvas) {
      var engine = new QtEng.QuotesEngine();
      var measureUnit = this.getCadWrapper().getConfigJSON().getMeasureUnit();
      var round = this.getCadWrapper().getConfigJSON().getViewMakerRound();
      var showMeasure = this.getCadWrapper().getConfigJSON().showMeasuresOnViewMaker();
      var arrowLabelScale = this.getCadWrapper().getConfigJSON().arrowLabelScale();
      engine.initialize(canvas, function () {}, null, measureUnit, round, showMeasure, arrowLabelScale);
      return engine;
    }
  }, {
    key: "setWallCatalog",
    value: function setWallCatalog(catalogName, wallCatalog) {
      this.getCadWrapper().setWallCatalog(catalogName, wallCatalog);
    }
  }, {
    key: "setCallback",
    value: function setCallback(callback) {
      this.onUpdate = callback;
    }
  }, {
    key: "lockCallbacks",
    value: function lockCallbacks(lock) {
      this.lockedCallbacks = lock;
    }
  }, {
    key: "getSharedData",
    value: function getSharedData() {
      return this.sharedData;
    }
  }, {
    key: "set3D",
    value: function set3D(eng3D) {
      this.get3DFunc = function () {
        return eng3D;
      };
    }
  }, {
    key: "get3D",
    value: function get3D() {
      return this.get3DFunc();
    }
  }, {
    key: "onResize3D",
    value: function onResize3D() {
      this.get3D().onWindowResize();
    }
  }, {
    key: "getCadWrapper",
    value: function getCadWrapper() {
      return this.getCadWrapperFunc();
    }
  }, {
    key: "getEnvWallJson",
    value: function getEnvWallJson() {
      return this.getCadWrapper().getEnvWallJson();
    }
  }, {
    key: "fromWallCadToRows",
    value: function fromWallCadToRows() {
      return this.getCadWrapper().fromWallCadToRows();
    }
  }, {
    key: "setCad2D",
    value: function setCad2D(cad) {
      this.getCadWrapperFunc = function () {
        return cad.getInputWrapper();
      };
    }
  }, {
    key: "scattaFoto",
    value: function scattaFoto(width, height, newWindow, bw, keepEffect) {
      return this.get3D().scattaFoto(width, height, newWindow, bw, keepEffect);
    }
  }, {
    key: "scattaFotoRow",
    value: function scattaFotoRow(row, width, height, fov, angX, angY, newWindow, bw, cb) {
      this.get3D().scattaFotoRow(row, width, height, fov, angX, angY, newWindow, bw, cb);
    }
  }, {
    key: "scattaFotoProject",
    value: function scattaFotoProject(project, width, height, fov, angX, angY, newWindow, bw, cb) {
      this.get3D().scattaFotoProject(project, width, height, fov, angX, angY, newWindow, bw, cb);
    }
  }, {
    key: "printScreen2D",
    value: function printScreen2D(width, height, centerZoom) {
      return this.getCadWrapper().printScreen2D(width, height, centerZoom);
    }
  }, {
    key: "setCadMode",
    value: function setCadMode(mode) {
      this.state = mode;
      switch (this.state) {
        case SH_CadState.CAD_2D:
          break;
        case SH_CadState.MOVE_3D:
          this.get3D().setCadMode(mode);
          break;
        case SH_CadState.H_MODE:
          this.get3D().setCadMode(mode);
          break;
        case SH_CadState.VIEW:
          this.get3D().setCadMode(mode);
          break;
        case SH_CadState.CONFIGURATOR:
          this.get3D().setCadMode(mode);
          break;
        case SH_CadState.PHOTO_MATCH:
          this.get3D().setCadMode(mode);
          break;
        case SH_CadState.VIEWMAKER:
          this.get3D().setCadMode(mode);
          break;
        case SH_CadState.CLOSET_TOOL:
          this.get3D().setCadMode(mode);
          break;
      }
    }
  }, {
    key: "selectObjByUniqueID",
    value: function selectObjByUniqueID(id) {
      switch (this.state) {
        case SH_CadState.CAD_2D:
          this.getCadWrapper().selectObjByUniqueID(id);
          break;
        case SH_CadState.MOVE_3D:
          this.getCadWrapper().selectObjByUniqueID(id);
          this.get3D().selectObjByUniqueID(id);
          break;
        case SH_CadState.H_MODE:
          this.getCadWrapper().selectObjByUniqueID(id);
          this.get3D().selectObjByUniqueID(id);
          break;
        case SH_CadState.VIEW:
          this.getCadWrapper().selectObjByUniqueID(id);
          this.get3D().selectObjByUniqueID(id);
          break;
        default:
          this.getCadWrapper().selectObjByUniqueID(id);
          break;
      }
    }
  }, {
    key: "forceSelectObjByUniqueid",
    value: function forceSelectObjByUniqueid(id) {
      switch (this.state) {
        case SH_CadState.CAD_2D:
          this.getCadWrapper().forceSelectObjByUniqueID(id);
          break;
        case SH_CadState.MOVE_3D:
          this.getCadWrapper().forceSelectObjByUniqueID(id);
          this.get3D().selectObjByUniqueID(id);
          break;
        case SH_CadState.H_MODE:
          this.getCadWrapper().forceSelectObjByUniqueID(id);
          this.get3D().selectObjByUniqueID(id);
          break;
        case SH_CadState.VIEW:
          this.getCadWrapper().forceSelectObjByUniqueID(id);
          this.get3D().selectObjByUniqueID(id);
          break;
        default:
          this.getCadWrapper().forceSelectObjByUniqueID(id);
          break;
      }
    }
  }, {
    key: "deleteItemByUniqueID",
    value: function deleteItemByUniqueID(id) {
      switch (this.state) {
        case SH_CadState.CAD_2D:
          this.getCadWrapper().deleteItemByUniqueID(id);
          break;
        case SH_CadState.MOVE_3D:
          this.deleteItemByUniqueID2D3D(id);
          break;
        case SH_CadState.H_MODE:
          this.deleteItemByUniqueID2D3D(id);
          break;
        case SH_CadState.VIEW:
          this.deleteItemByUniqueID2D3D(id);
          break;
        default:
          this.getCadWrapper().deleteItemByUniqueID(id);
          break;
      }
    }
  }, {
    key: "deleteItemByUniqueID2D3D",
    value: function deleteItemByUniqueID2D3D(id) {
      this.getCadWrapper().deleteItemByUniqueID(id);
      this.get3D().deleteSelectedItems([new WE_CadID(id, true)]);
      var selectedBox = this.getCadWrapper().getSelectedBoxRow();
      if (selectedBox) {
        this.get3D().selectObjByUniqueID(selectedBox.uniqueid);
      }
    }
  }, {
    key: "deleteSelectedItem",
    value: function deleteSelectedItem() {
      switch (this.state) {
        case SH_CadState.CAD_2D:
          this.getCadWrapper().deleteSelectedItem();
          break;
        case SH_CadState.MOVE_3D:
          this.deleteSelectedItem2D3D();
          break;
        case SH_CadState.H_MODE:
          this.deleteSelectedItem2D3D();
          break;
        case SH_CadState.VIEW:
          this.deleteSelectedItem2D3D();
          break;
        default:
          this.getCadWrapper().deleteSelectedItem();
          break;
      }
    }
  }, {
    key: "deleteSelectedItem2D3D",
    value: function deleteSelectedItem2D3D() {
      var cadIDs = this.getCadWrapper().deleteSelectedItem();
      this.get3D().deleteSelectedItems(cadIDs);
      var selectedBox = this.getCadWrapper().getSelectedBoxRow();
      if (selectedBox) {
        this.get3D().selectObjByUniqueID(selectedBox.uniqueid);
      }
    }
  }, {
    key: "deleteSelectedBox2D3D",
    value: function deleteSelectedBox2D3D() {
      var cadIDs = this.getCadWrapper().deleteSelectedBox();
      this.get3D().deleteSelectedItems(cadIDs);
      var selectedBox = this.getCadWrapper().getSelectedBoxRow();
      if (selectedBox) {
        this.get3D().selectObjByUniqueID(selectedBox.uniqueid);
      }
    }
  }, {
    key: "getSelectedBoxRow",
    value: function getSelectedBoxRow() {
      return this.getCadWrapper().getSelectedBoxRow();
    }
  }, {
    key: "getSelectedBoxRows",
    value: function getSelectedBoxRows() {
      return this.getCadWrapper().getSelectedBoxesRows();
    }
  }, {
    key: "removeAllGroups",
    value: function removeAllGroups() {
      this.getCadWrapper().removeAllGroups();
    }
  }, {
    key: "getMultiSelectionState",
    value: function getMultiSelectionState() {
      return this.getCadWrapper().getMultiSelection();
    }
  }, {
    key: "setMultiSelection",
    value: function setMultiSelection(enable) {
      this.getCadWrapper().setMultiSelection(enable);
    }
  }, {
    key: "setMultiSelectionType",
    value: function setMultiSelectionType(type) {
      this.getCadWrapper().setMultiSelectionType(type);
    }
  }, {
    key: "isSnapEnabled",
    value: function isSnapEnabled() {
      return this.getCadWrapper().isSnapEnabled();
    }
  }, {
    key: "setSnapEnabled",
    value: function setSnapEnabled(enable) {
      this.getCadWrapper().setSnapEnabled(enable);
    }
  }, {
    key: "isCollisionEnabled",
    value: function isCollisionEnabled() {
      return this.getCadWrapper().isCollisionEnabled();
    }
  }, {
    key: "setCollisionEnabled",
    value: function setCollisionEnabled(enable) {
      this.getCadWrapper().setCollisionEnabled(enable);
    }
  }, {
    key: "isMagicEnabled",
    value: function isMagicEnabled() {
      return this.getCadWrapper().isMagicEnabled();
    }
  }, {
    key: "setMagicEnabled",
    value: function setMagicEnabled(enable) {
      this.getCadWrapper().setMagicEnabled(enable);
    }
  }, {
    key: "canBoxSnapOnWall",
    value: function canBoxSnapOnWall() {
      return this.getCadWrapper().canBoxSnapOnWall();
    }
  }, {
    key: "changeActiveBoxSnapWall",
    value: function changeActiveBoxSnapWall(change) {
      this.getCadWrapper().changeActiveBoxSnapWall(change);
    }
  }, {
    key: "changeBoxesSnapWall",
    value: function changeBoxesSnapWall(change) {
      this.getCadWrapper().changeBoxesSnapWall(change);
    }
  }, {
    key: "getLayersExtData",
    value: function getLayersExtData() {
      return this.getCadWrapper().getLayersExtData();
    }
  }, {
    key: "setLayerActive",
    value: function setLayerActive(layer) {
      this.getCadWrapper().setLayerActive(layer);
    }
  }, {
    key: "setLayerInactive",
    value: function setLayerInactive(layer) {
      this.getCadWrapper().setLayerInactive(layer);
    }
  }, {
    key: "showLayer",
    value: function showLayer(layerType) {
      this.getCadWrapper().showLayer(layerType);
    }
  }, {
    key: "enableBoundingQuote",
    value: function enableBoundingQuote(enable) {
      this.getCadWrapper().enableBoundingQuote(enable);
    }
  }, {
    key: "boundingQuoteEnabled",
    value: function boundingQuoteEnabled() {
      return this.getCadWrapper().boundingQuoteEnabled();
    }
  }, {
    key: "selectAllBoxes",
    value: function selectAllBoxes() {
      console.log("Move inside shared data");
      this.getCadWrapper().selectAllBoxes();
      var row = this.getCadWrapper().getActiveItemRow();
      if (row) {
        this.get3D().selectObjByUniqueID(row.uniqueid);
      }
    }
  }, {
    key: "deselectAll",
    value: function deselectAll() {
      console.log("Move inside shared data");
      this.getCadWrapper().deselectAll();
    }
  }, {
    key: "rotateSelectedBoxesIncrement",
    value: function rotateSelectedBoxesIncrement(value) {
      this.getCadWrapper().rotateSelectedBoxesIncrement(value);
      switch (this.state) {
        case SH_CadState.CAD_2D:
          break;
        case SH_CadState.MOVE_3D:
          this.get3D().positionsFromWalls();
          break;
        case SH_CadState.VIEW:
          this.get3D().positionsFromWalls();
          break;
        default:
          console.log("Cannot rotete icad");
          break;
      }
    }
  }, {
    key: "getActiveTypedRow",
    value: function getActiveTypedRow() {
      return this.getCadWrapper().getActiveTypedRow();
    }
  }, {
    key: "selectPlacerSlot",
    value: function selectPlacerSlot(res) {
      switch (this.state) {
        case SH_CadState.CAD_2D:
          console.log("Cannot insert placer in 2D view");
          break;
        case SH_CadState.MOVE_3D:
          this.get3D().setSelectSlotMode(true, res);
          break;
        case SH_CadState.VIEW:
          this.get3D().setSelectSlotMode(true, res);
          break;
        default:
          console.log("Cannot insert placer without 3D mode");
          break;
      }
    }
  }, {
    key: "insertBox",
    value: function insertBox(project, substitute) {
      var afterInsert = this.getCadWrapper().insertBox(project, substitute);
      var iCadEnum = AfterInsertEnum.NOTHING;
      switch (afterInsert) {
        case WE_AfterInsertEnum.RE_EVAL_OBJ:
          iCadEnum = AfterInsertEnum.RE_EVAL_OBJ;
          break;
      }
      return iCadEnum;
    }
  }, {
    key: "insertBoxPlacer",
    value: function insertBoxPlacer(project) {
      var afterInsert = this.getCadWrapper().insertBoxPlacer(project);
      var iCadEnum = AfterInsertEnum.NOTHING;
      switch (afterInsert) {
        case WE_AfterInsertEnum.RE_EVAL_OBJ:
          iCadEnum = AfterInsertEnum.RE_EVAL_OBJ;
          break;
      }
      return iCadEnum;
    }
  }, {
    key: "insertBoxFreePosition",
    value: function insertBoxFreePosition(project, x, y, z, axz) {
      this.getCadWrapper().insertBoxFreePosition(project, new pt3d().set(Number(x), Number(y), Number(z)), Number(axz));
      return AfterInsertEnum.NOTHING;
    }
  }, {
    key: "duplicateItem",
    value: function duplicateItem(item) {
      console.error("Deprecate duplicate ICAD");
    }
  }, {
    key: "insertItemDuplicate",
    value: function insertItemDuplicate(project, duplicateRows, oldID) {
      var afterDuplicate = this.getCadWrapper().insertItemsDuplicate(project, duplicateRows, oldID);
      if (afterDuplicate == WE_AfterInsertEnum.MOVE_SELECTED) {
        switch (this.state) {
          case SH_CadState.CAD_2D:
            this.getCadWrapper().setMoveSelectedItemsMode();
            break;
          case SH_CadState.VIEW:
          case SH_CadState.MOVE_3D:
            this.get3D().setMoveSelectedItemsMode();
            break;
        }
      }
    }
  }, {
    key: "duplicateItems",
    value: function duplicateItems() {
      var itemsToClone = this.getCadWrapper().duplicateDirect();
      if (itemsToClone.length > 0) {
        switch (this.state) {
          case SH_CadState.CAD_2D:
            this.getCadWrapper().callback2D(WE_EnumEvents.DUPLICATE_ITEM, itemsToClone);
            break;
          case SH_CadState.VIEW:
          case SH_CadState.MOVE_3D:
            this.get3D().generalCallback(Eng3d_Callbacks.DUPLICATE_ITEM, itemsToClone);
            break;
        }
      }
    }
  }, {
    key: "moveBoxPlacer",
    value: function moveBoxPlacer(project, row) {
      this.getCadWrapper().moveBoxPlacer(project, row);
    }
  }, {
    key: "exportGLTF",
    value: function exportGLTF(cbDone, cbError, options) {
      this.get3D().exportGLTF(cbDone, cbError, options);
    }
  }, {
    key: "exportJsonScene",
    value: function exportJsonScene() {
      this.sharedDataCallback(SharedCallbackEnums.EXPORT_JSON_SCENE, this.get3D().getJsonScene(), CallbackEnumType.SHARED);
    }
  }, {
    key: "exportJsonSceneRows",
    value: function exportJsonSceneRows(rows) {
      this.sharedDataCallback(SharedCallbackEnums.EXPORT_JSON_SCENE, this.get3D().getJsonSceneRows(rows), CallbackEnumType.SHARED);
    }
  }, {
    key: "getNewDividerWrapper",
    value: function getNewDividerWrapper() {
      var divider = new MainDivider();
      return divider.getInputWrapper();
    }
  }, {
    key: "unjoinWall",
    value: function unjoinWall() {
      this.getCadWrapper().unjoinSelected();
    }
  }, {
    key: "moveToNewOrigin",
    value: function moveToNewOrigin() {
      this.getCadWrapper().moveToNewOrigin();
    }
  }, {
    key: "initializeCanvasYTool",
    value: function initializeCanvasYTool(data) {
      this.getCadWrapper().initializeCanvasYTool(data.data, data.callBack);
    }
  }, {
    key: "setProject",
    value: function setProject(project, noCenterZoom) {
      this.lockCallbacks(true);
      this.getCadWrapper().setProject(project, noCenterZoom);
      this.lockCallbacks(false);
    }
  }, {
    key: "createWalls",
    value: function createWalls(points, hWalls, cod, reg) {
      this.getCadWrapper().createWalls(points, hWalls, cod, reg);
    }
  }, {
    key: "createWallsWFloor",
    value: function createWallsWFloor(wallPoints, floorPoints, hWalls, cod, reg) {
      return this.getCadWrapper().createWallsWFloor(wallPoints, floorPoints, hWalls, cod, reg);
    }
  }, {
    key: "applyGallery",
    value: function applyGallery(galleryData, project) {
      this.getCadWrapper().applyGallery(galleryData, project);
    }
  }, {
    key: "applyGalleryLayout",
    value: function applyGalleryLayout(galleryData, project) {
      this.getCadWrapper().applyGalleryLayout(galleryData, project);
    }
  }, {
    key: "getGallery",
    value: function getGallery() {
      return this.getCadWrapper().getGallery();
    }
  }, {
    key: "createPreconf",
    value: function createPreconf(script) {
      this.getCadWrapper().createPreconf(script);
    }
  }, {
    key: "drawwallPRO",
    value: function drawwallPRO(tipo, codice, regola, script, catalog) {
      this.getCadWrapper().drawwallPRO(tipo, codice, regola, script, catalog);
    }
  }, {
    key: "createPillar",
    value: function createPillar(codice, regola, desc, catalog, dragImg, extraEval) {
      return this.getCadWrapper().createPillar(codice, regola, desc, catalog, dragImg, extraEval);
    }
  }, {
    key: "createWindowPRO",
    value: function createWindowPRO(tipo, codice, regola, script, desc, l, a, p, colonna, hterra, forced, catalog, dragImg) {
      return this.getCadWrapper().createWindowPRO(tipo, codice, regola, script, desc, l, a, p, colonna, hterra, forced, catalog, dragImg);
    }
  }, {
    key: "createWindowPROSvg",
    value: function createWindowPROSvg(tipo, codice, regola, script, desc, l, a, p, colonna, hterra, forced, catalog, dragImg, extraEval) {
      return this.getCadWrapper().createWindowPROSvg(tipo, codice, regola, script, desc, l, a, p, colonna, hterra, forced, catalog, dragImg, extraEval);
    }
  }, {
    key: "startDragFloor",
    value: function startDragFloor(tipo, codice, regola, script, desc, colonna, hterra, catalog) {
      this.getCadWrapper().startDragFloor(tipo, codice, regola, script, desc, colonna, hterra, catalog);
    }
  }, {
    key: "insertDraggerValue",
    value: function insertDraggerValue(value) {
      var valParsed = Number(value);
      this.get3D().setMovingDragerValue(valParsed);
    }
  }, {
    key: "setState",
    value: function setState(project, shDataState, progress) {
      var _this2 = this;
      this.lockedCallbacks = true;
      var xThis = this;
      this.state = shDataState.getIcadState();
      return new _promise["default"](function (resolve, reject) {
        try {
          var internalEndCb = function internalEndCb() {
            xThis.lockedCallbacks = false;
            resolve(null);
          };
          _this2.getCadWrapper().restoreState(project, shDataState);
          internalEndCb();
        } catch (error) {
          console.error(error);
          _this2.lockedCallbacks = false;
          reject(error);
        }
      });
    }
  }, {
    key: "getState",
    value: function getState() {
      var envWallJson = this.getCadWrapper().getProjectEnvWallJson();
      var sharedClone = this.getSharedData().cloneShallow();
      if (this.get3D().getClosetToolIfEnabled()) {
        sharedClone.setClonedClosetIstance(this.get3D().getClosetToolIfEnabled().getClonedCloestInstanceFn());
      } else {
        sharedClone = this.getSharedData().cloneShallow();
      }
      return new SH_DataState(sharedClone, envWallJson, this.state);
    }
  }, {
    key: "setbackgroundURL",
    value: function setbackgroundURL(url) {
      this.get3D().setbackgroundURL(url);
    }
  }, {
    key: "getPhotoBackgroundUrl",
    value: function getPhotoBackgroundUrl() {
      return this.get3D().getPhotoBackgroundUrl();
    }
  }, {
    key: "enablePhotoMatch",
    value: function enablePhotoMatch(enable) {
      this.get3D().enablePhotoMatch(enable);
    }
  }, {
    key: "getPhotoJSON",
    value: function getPhotoJSON() {
      return this.get3D().getPhotoJSON();
    }
  }, {
    key: "setPhotoJSON",
    value: function setPhotoJSON(json, cbDone) {
      this.get3D().setPhotoJSON(json, cbDone);
    }
  }, {
    key: "setPhotoMatchPhase",
    value: function setPhotoMatchPhase(enumPhase) {
      this.get3D().setPhotoMatchPhase(enumPhase);
    }
  }, {
    key: "getPhotoMatchPhase",
    value: function getPhotoMatchPhase() {
      return this.get3D().getPhotoMatchPhase();
    }
  }, {
    key: "getMinFocalLength",
    value: function getMinFocalLength() {
      return this.get3D().getMinFocalLength();
    }
  }, {
    key: "getMaxFocalLength",
    value: function getMaxFocalLength() {
      return this.get3D().getMaxFocalLength();
    }
  }, {
    key: "getActualFocalLength",
    value: function getActualFocalLength() {
      return this.get3D().getActualFocalLength();
    }
  }, {
    key: "updateFocalLength",
    value: function updateFocalLength(length) {
      this.get3D().updateFocalLength(length);
    }
  }, {
    key: "saveMask",
    value: function saveMask() {
      this.get3D().saveMask();
    }
  }, {
    key: "getMaskList",
    value: function getMaskList() {
      return this.get3D().getMaskList();
    }
  }, {
    key: "deleteMaskByID",
    value: function deleteMaskByID(id) {
      this.get3D().deleteMaskByID(id);
    }
  }, {
    key: "load3D",
    value: function load3D(canvas3D, canvasQuote3D, config, lockVisual, callback, noAntialias) {
      this.get3D().load3D(canvas3D, canvasQuote3D, config, callback, lockVisual, this.getCadWrapper().getCad(), noAntialias);
    }
  }, {
    key: "drawAll",
    value: function drawAll() {
      var _this3 = this;
      var drawTops = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var prj = arguments.length > 1 ? arguments[1] : undefined;
      var cb = arguments.length > 2 ? arguments[2] : undefined;
      var progress = arguments.length > 3 ? arguments[3] : undefined;
      var mustCenterZoom = arguments.length > 4 ? arguments[4] : undefined;
      switch (this.state) {
        case SH_CadState.MOVE_3D:
        case SH_CadState.VIEW:
          this.get3D().NodeCreateRoot();
          prj.eval3dwall = null;
          prj.eval3dtops = null;
          this.get3D().drawWalls(prj, function () {
            _this3.get3D().drawProject(prj, drawTops, function () {
              if (cb) cb();
            }, progress, mustCenterZoom);
          });
          break;
        default:
          console.error("Catalog Error, ICAD drawAll is in wrong state");
          if (cb) cb();
          break;
      }
    }
  }, {
    key: "draw",
    value: function draw(scene, endedCallback, mustCenterZoom) {
      this.get3D().generaScenaScript(scene, endedCallback, mustCenterZoom);
    }
  }, {
    key: "drawRow",
    value: function drawRow(row, endedCallback, progress, mustCenterZoom, mustEvalTops) {
      this.get3D().drawRowAsync(row, endedCallback, progress, mustCenterZoom, mustEvalTops);
    }
  }, {
    key: "centerZoom",
    value: function centerZoom() {
      switch (this.state) {
        case SH_CadState.CAD_2D:
          this.getCadWrapper().centerZoom();
          break;
        case SH_CadState.MOVE_3D:
          console.error("Missing center zoom fucntion on 3D");
          break;
        case SH_CadState.VIEW:
          console.error("Missing center zoom fucntion on 3D");
          break;
        default:
          break;
      }
    }
  }, {
    key: "zoomWindow",
    value: function zoomWindow(enable) {
      switch (this.state) {
        case SH_CadState.CAD_2D:
          this.getCadWrapper().zoomWindow(enable);
          break;
        case SH_CadState.MOVE_3D:
          this.get3D().enableZoomWindow(enable);
          break;
        case SH_CadState.VIEW:
          this.get3D().enableZoomWindow(enable);
          break;
        default:
          break;
      }
    }
  }, {
    key: "isZoomWindowEnabled",
    value: function isZoomWindowEnabled() {
      var enabled = false;
      switch (this.state) {
        case SH_CadState.CAD_2D:
          break;
        case SH_CadState.MOVE_3D:
          enabled = this.get3D().isZoomWindowEnabled();
          break;
        case SH_CadState.VIEW:
          enabled = this.get3D().isZoomWindowEnabled();
          break;
        default:
          break;
      }
      return enabled;
    }
  }, {
    key: "renumberBoxes",
    value: function renumberBoxes() {
      if (this.state == SH_CadState.CAD_2D) {
        this.getCadWrapper().reNumberBoxes();
      } else {
        this.get3D().reNumberBoxes();
      }
    }
  }, {
    key: "changeHModeNew",
    value: function changeHModeNew(mode, wallGUID, lockCamera, show_entire_scene) {
      this.get3D().changeHModeNew(mode, wallGUID, lockCamera, show_entire_scene);
    }
  }, {
    key: "changeHMode",
    value: function changeHMode(mode) {
      this.get3D().changeHMode(mode);
    }
  }, {
    key: "isInHMode",
    value: function isInHMode() {
      return this.get3D().isInHMode();
    }
  }, {
    key: "isInMode3D",
    value: function isInMode3D() {
      return this.get3D().isInMode3D();
    }
  }, {
    key: "goToView",
    value: function goToView(view, quotesEngine) {
      this.get3D().viewMaker.setQuotesEngine(quotesEngine);
      this.get3D().viewMaker.goToView(view, null, null);
    }
  }, {
    key: "saveViewMakerOnPrj",
    value: function saveViewMakerOnPrj(qtEng) {
      this.get3D().saveActualViewMaker(qtEng);
    }
  }, {
    key: "setDragAccessoryOnViewMaker",
    value: function setDragAccessoryOnViewMaker(qtEng, accessory) {
      qtEng.getInputWrapper().setDraggingAccessory(accessory);
    }
  }, {
    key: "clearAllWalls",
    value: function clearAllWalls() {
      this.getCadWrapper().clearAllWalls();
    }
  }, {
    key: "getDragAccessoryViewMaker",
    value: function getDragAccessoryViewMaker() {
      return this.get3D().viewMaker.getViewMakerAccessory();
    }
  }, {
    key: "saveUserView",
    value: function saveUserView() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        hideWall: true,
        resolution: {
          x: 1280,
          y: 800
        }
      };
      var project = arguments.length > 1 ? arguments[1] : undefined;
      this.get3D().takeNewUserView("Custom View", config, project);
    }
  }, {
    key: "enableDivLayers",
    value: function enableDivLayers(layersArray) {
      this.get3D().divMakerEng.setDIVLayers(layersArray);
    }
  }, {
    key: "free3DEngine",
    value: function free3DEngine() {
      this.get3D().freeEngine();
    }
  }, {
    key: "redraw",
    value: function redraw(mode) {
      this.get3D().redraw(mode);
    }
  }, {
    key: "updatePositions",
    value: function updatePositions(d1, d2, d3, d4, x, y, z) {
      this.getCadWrapper().updateQuotesFromPositions(d1, d2, d3, d4, x, y, z);
      switch (this.state) {
        case SH_CadState.MOVE_3D:
        case SH_CadState.VIEW:
          this.get3D().positionsFromWalls();
      }
    }
  }, {
    key: "change3DMove",
    value: function change3DMove(flag) {
      this.get3D().change3DMove(flag);
    }
  }, {
    key: "view3d0",
    value: function view3d0() {
      this.get3D().view3d0();
    }
  }, {
    key: "view3d1",
    value: function view3d1() {
      this.get3D().view3d1();
    }
  }, {
    key: "viewsidel",
    value: function viewsidel() {
      this.get3D().viewsidel();
    }
  }, {
    key: "viewsider",
    value: function viewsider() {
      this.get3D().viewsider();
    }
  }, {
    key: "viewtop",
    value: function viewtop() {
      this.get3D().viewtop();
    }
  }, {
    key: "viewfront",
    value: function viewfront() {
      this.get3D().viewfront();
    }
  }, {
    key: "setCircleQuoteStyle",
    value: function setCircleQuoteStyle(json) {
      this.getSharedData().setCircleQuoteStyle(json);
    }
  }, {
    key: "setJsonQuoteDynamicinearStyle",
    value: function setJsonQuoteDynamicinearStyle(json) {
      this.get3D().setJsonQuoteDynamicinearStyle(json);
    }
  }, {
    key: "setJsonQuoteBoundingBox",
    value: function setJsonQuoteBoundingBox(json) {
      this.get3D().setJsonQuoteBoundingBox(json);
    }
  }, {
    key: "enableCircleQuotes",
    value: function enableCircleQuotes(enable) {
      if (this.state == SH_CadState.CAD_2D) {
        this.getCadWrapper().enableCircleQuotes(enable);
      } else {
        this.get3D().enableCircleQuotes(enable);
      }
    }
  }, {
    key: "preUpdateRules",
    value: function preUpdateRules() {
      this.getCadWrapper().beforeUpdateRule();
    }
  }, {
    key: "afterUpdateRules",
    value: function afterUpdateRules() {
      this.getCadWrapper().applicaRivaluta();
    }
  }, {
    key: "convertOldWalls",
    value: function convertOldWalls() {
      this.getCadWrapper().convertOldWalls();
    }
  }, {
    key: "hasOldWalls",
    value: function hasOldWalls() {
      return this.getCadWrapper().hasOldWalls();
    }
  }, {
    key: "reEvaluateCornerUnit",
    value: function reEvaluateCornerUnit(rowID) {
      this.getCadWrapper().reEvaluateCornerUnit(rowID);
    }
  }, {
    key: "setWallCreationData",
    value: function setWallCreationData(length, depth) {
      this.getCadWrapper().setWallCreationData(length, depth);
    }
  }, {
    key: "setSelectNewOrigin",
    value: function setSelectNewOrigin(select) {
      this.getCadWrapper().setSelectNewOrigin(select);
    }
  }, {
    key: "getNewOriginState",
    value: function getNewOriginState() {
      return this.getCadWrapper().getNewOriginState();
    }
  }, {
    key: "createGroup",
    value: function createGroup() {
      this.getCadWrapper().createGroup();
    }
  }, {
    key: "removeGroup",
    value: function removeGroup() {
      this.getCadWrapper().removeGroup();
    }
  }, {
    key: "hideLayer",
    value: function hideLayer(layerType) {
      this.getCadWrapper().hideLayer(layerType);
    }
  }, {
    key: "getData2DBox",
    value: function getData2DBox(uid) {
      return this.getCadWrapper().getData2DBox(uid);
    }
  }, {
    key: "enableViewMakerProject",
    value: function enableViewMakerProject(project, loadJson, quotesEngine, goToFirst, forceNew) {
      var _this4 = this;
      return new _promise["default"](function (resolve, reject) {
        _this4.setCadMode(SH_CadState.VIEWMAKER);
        _this4.get3D().viewMaker.setQuotesEngine(quotesEngine);
        _this4.get3D().viewMaker.prepareViewMaker(project, loadJson, function (json) {
          resolve(json);
        }, goToFirst, forceNew);
      });
    }
  }, {
    key: "enableViewMakerRow",
    value: function enableViewMakerRow(row, loadJson, quotesEngine, goToFirst, forceNew) {
      var _this5 = this;
      return new _promise["default"](function (resolve, reject) {
        _this5.setCadMode(SH_CadState.VIEWMAKER);
        _this5.get3D().viewMaker.setQuotesEngine(quotesEngine);
        _this5.get3D().viewMaker.prepareViewMakerRow(row, loadJson, function (json) {
          resolve(json);
        }, goToFirst, forceNew);
      });
    }
  }, {
    key: "canEditViewMaker",
    value: function canEditViewMaker() {
      return this.getCadWrapper().canEditViewMaker();
    }
  }, {
    key: "setBackFaceCulling",
    value: function setBackFaceCulling(mode) {
      this.get3D().setBackFaceCulling(mode);
    }
  }, {
    key: "getBackFaceCulling",
    value: function getBackFaceCulling() {
      return this.get3D().getBackFaceCulling();
    }
  }, {
    key: "setBoxCulling",
    value: function setBoxCulling(mode) {
      this.get3D().setBoxCulling(mode);
    }
  }, {
    key: "getBoxCulling",
    value: function getBoxCulling() {
      return this.get3D().getBoxCulling();
    }
  }, {
    key: "hasAddLinksChoice",
    value: function hasAddLinksChoice(project) {
      var hasAddLinksChoice = false;
      this.getCadWrapper().hasAddLinkChoice(project);
      return hasAddLinksChoice;
    }
  }, {
    key: "getAddLinksToInsertOn",
    value: function getAddLinksToInsertOn(project) {
      var addLinks = this.getCadWrapper().getAddLinksToInsertOn(project);
      return addLinks;
    }
  }, {
    key: "insertBoxByAddLinks",
    value: function insertBoxByAddLinks(addLinks, project) {
      return this.getCadWrapper().insertBoxByAddLinks(addLinks, project);
    }
  }, {
    key: "toggleQuoteEditor",
    value: function toggleQuoteEditor(toggle) {
      this.getCadWrapper().enableQuoteEditor(toggle);
    }
  }, {
    key: "toggle2DMap",
    value: function toggle2DMap(toggle) {
      this.getCadWrapper().toggle2DMap(toggle);
    }
  }, {
    key: "loadMap2DImage",
    value: function loadMap2DImage(image) {
      this.getCadWrapper().loadMap2DImage(image);
    }
  }, {
    key: "setMap2DMeasure",
    value: function setMap2DMeasure() {
      this.getCadWrapper().setMap2DMeasure();
    }
  }, {
    key: "setDragMap2DMode",
    value: function setDragMap2DMode(enable) {
      this.getCadWrapper().setDragMap2DMode(enable);
    }
  }, {
    key: "applyMeasureOnMap2D",
    value: function applyMeasureOnMap2D(measure) {
      this.getCadWrapper().applyMeasureOnMap2D(measure);
    }
  }, {
    key: "renderAllViews",
    value: function renderAllViews(project, getJsonFn, configJson, viewMakerDoneCb, forceRecreate, is2D, callbackForReval, wallWrapper, noAntialias) {
      if (is2D) {
        wallWrapper.renderAllViews(project, getJsonFn, configJson, viewMakerDoneCb, forceRecreate);
      } else {
        var sharedData = new SharedData();
        var x = this;
        sharedData.registerIcadCallback(function (event, data, type) {
          x.sharedDataCallback(event, data, type);
        });
        var tmpCadEng = new CadEngine(sharedData);
        var cadNiuv = new WE_Cad("", configJson, sharedData);
        cadNiuv.initialize(null, null);
        cadNiuv.getInputWrapper().setProject(project, false);
        tmpCadEng.renderAllViews(project, getJsonFn, configJson, viewMakerDoneCb, forceRecreate, cadNiuv, noAntialias);
      }
    }
  }, {
    key: "test",
    value: function test() {}
  }, {
    key: "setCameraMode3D",
    value: function setCameraMode3D(mode) {
      this.get3D().setLockVisualMode(mode);
    }
  }, {
    key: "getCameraMode3D",
    value: function getCameraMode3D() {
      return this.get3D().getCameraMode();
    }
  }, {
    key: "setLockedMode",
    value: function setLockedMode(locked) {
      this.getSharedData().setLockedMode(locked);
    }
  }, {
    key: "createView",
    value: function createView(fov, ax, ay) {
      this.get3D().CreateView(fov, ax, ay);
    }
  }, {
    key: "getClosetWrapper",
    value: function getClosetWrapper() {
      return this.get3D().getClosetToolWrapper();
    }
  }, {
    key: "setClosetFromRow_CL",
    value: function setClosetFromRow_CL(row, variants, configJson) {
      return this.getClosetWrapper().setCloset(row, variants, configJson);
    }
  }, {
    key: "setAllClosetsFromRows_CL",
    value: function setAllClosetsFromRows_CL(rows, variants, configJson) {
      return this.getClosetWrapper().setClosetFromRows(rows, variants, configJson);
    }
  }, {
    key: "getVariants_CL",
    value: function getVariants_CL() {
      return this.getClosetWrapper().getVariants(null);
    }
  }, {
    key: "getVariants_CL_idRow",
    value: function getVariants_CL_idRow(idRow) {
      return this.getClosetWrapper().getVariants(idRow);
    }
  }, {
    key: "fromClosetToRule_CL",
    value: function fromClosetToRule_CL(row) {
      this.getClosetWrapper().fromClosetToRule(row);
    }
  }, {
    key: "undo_CL",
    value: function undo_CL() {
      return this.getClosetWrapper().undo();
    }
  }, {
    key: "redo_CL",
    value: function redo_CL() {
      return this.getClosetWrapper().redo();
    }
  }, {
    key: "getColumns_CL",
    value: function getColumns_CL() {
      throw "DEPRECATED_getColumns_CL";
    }
  }, {
    key: "getMinColumns_CL",
    value: function getMinColumns_CL() {
      throw "DEPRECATED_getMinColumns_CL";
    }
  }, {
    key: "getMaxColumns_CL",
    value: function getMaxColumns_CL() {
      throw "DEPRECATED_getMaxColumns_CL";
    }
  }, {
    key: "setColumns_CL",
    value: function setColumns_CL(columns) {
      throw "DEPRECATED setColumns_CL";
    }
  }, {
    key: "showAreaSelect_CL",
    value: function showAreaSelect_CL(show) {
      console.log("DEPRECATED showAreaSelect_CL");
    }
  }, {
    key: "selectArea_CL",
    value: function selectArea_CL(areaID) {
      throw "DEPRECATED selectArea_CL";
    }
  }, {
    key: "setDragDataItem_CL",
    value: function setDragDataItem_CL(itemVariant) {
      this.getClosetWrapper().setVariantDragItem(itemVariant);
    }
  }, {
    key: "setDragDataMacro_CL",
    value: function setDragDataMacro_CL(macroVariant) {
      this.getClosetWrapper().setVariantDragMacro(macroVariant);
    }
  }, {
    key: "setDragDataMerge_CL",
    value: function setDragDataMerge_CL(mergeVariant) {
      this.getClosetWrapper().setVariantDragMerge(mergeVariant);
    }
  }, {
    key: "setDragDataFrontals_CL",
    value: function setDragDataFrontals_CL(frontalsVariant) {
      this.getClosetWrapper().setVariantDragFrontal(frontalsVariant);
    }
  }, {
    key: "showQuotes_CL",
    value: function showQuotes_CL(show) {
      this.getClosetWrapper().showQuotes(show);
    }
  }, {
    key: "setProgressiveQuote_CL",
    value: function setProgressiveQuote_CL(enable) {
      this.getClosetWrapper().setProgressiveQuote(enable);
    }
  }, {
    key: "resolveWallAnswer",
    value: function resolveWallAnswer(evWallRes) {
      this.getCadWrapper().resolveWallAnswer(evWallRes);
    }
  }, {
    key: "lockColumnByGuid_CL",
    value: function lockColumnByGuid_CL(guid, lock, rowId) {
      this.getClosetWrapper().lockColumnByGuid(Number(guid), lock, rowId);
    }
  }, {
    key: "applyColumnWidth_CL",
    value: function applyColumnWidth_CL(guid, width, rowId) {
      this.getClosetWrapper().applyColumnWidth_CL(Number(guid), Number(width), rowId);
    }
  }, {
    key: "getColumnWidth_CL",
    value: function getColumnWidth_CL(guid, rowId) {
      return this.getClosetWrapper().getColumnWidth_CL(Number(guid), rowId);
    }
  }, {
    key: "showQuotesColumn_CL",
    value: function showQuotesColumn_CL(guid, show, rowId) {
      this.getClosetWrapper().showQuotesColumn(Number(guid), show, rowId);
    }
  }, {
    key: "keepClosetChanges_CL",
    value: function keepClosetChanges_CL() {
      this.getClosetWrapper().keepClosetChanges();
    }
  }, {
    key: "applyClosetNoChages_CL",
    value: function applyClosetNoChages_CL(row) {
      this.getClosetWrapper().applyClosetNoChanges(row);
    }
  }, {
    key: "deleteColumnItems_CL",
    value: function deleteColumnItems_CL(columnID, rowId) {
      this.getClosetWrapper().deleteColumnItems(columnID, rowId);
    }
  }, {
    key: "applyItemPosition_CL",
    value: function applyItemPosition_CL(guid, x, y, positionType, rowId) {
      this.getClosetWrapper().applyItemPosition(guid, x, y, positionType, rowId);
    }
  }, {
    key: "deleteMergeArea_CL",
    value: function deleteMergeArea_CL(mergeID, rowID) {
      this.getClosetWrapper().deleteMergeArea(mergeID, rowID);
    }
  }, {
    key: "deleteFrontal_CL",
    value: function deleteFrontal_CL(frontalID, rowID) {
      this.getClosetWrapper().deleteFrontal(frontalID, rowID);
    }
  }, {
    key: "splitFrontalHorizontal_CL",
    value: function splitFrontalHorizontal_CL(frontalID, splitNumber, rowID) {
      this.getClosetWrapper().splitFrontalHorizontal(frontalID, splitNumber, rowID);
    }
  }, {
    key: "applyMergesChanges",
    value: function applyMergesChanges(guid, bottom, height, rowId) {
      this.getClosetWrapper().applyMergesChanges(guid, bottom, height, rowId);
    }
  }, {
    key: "applyFrontalChanges",
    value: function applyFrontalChanges(guid, bottom, height, offsetLeft, offsetRight, offsetTop, offsetBottom, rowId) {
      this.getClosetWrapper().applyFrontalChanges(guid, bottom, height, offsetLeft, offsetRight, offsetTop, offsetBottom, rowId);
    }
  }, {
    key: "applyColumnDepthChanges",
    value: function applyColumnDepthChanges(guid, depth, rowId) {
      this.getClosetWrapper().applyColumnDepthChanges(guid, depth, rowId);
    }
  }, {
    key: "applyColumnHeightChanges",
    value: function applyColumnHeightChanges(guid, heightFloor, height, rowId) {
      this.getClosetWrapper().applyColumnHeightChanges(guid, heightFloor, height, rowId);
    }
  }, {
    key: "isAreaLocked_CL",
    value: function isAreaLocked_CL(guid, idRow) {
      return this.getClosetWrapper().isAreaLocked(guid, idRow);
    }
  }, {
    key: "setOptionalBackPanel_CL",
    value: function setOptionalBackPanel_CL(guid, idRow, boolState) {
      this.getClosetWrapper().setOptionalBackPanel(guid, idRow, boolState);
    }
  }, {
    key: "setMode_CL",
    value: function setMode_CL(mode) {
      return this.getClosetWrapper().setClosetMode(mode);
    }
  }, {
    key: "setClosetFrontalQuoteMode_CL",
    value: function setClosetFrontalQuoteMode_CL(mode) {
      this.getClosetWrapper().setClosetFrontalQuoteMode(mode);
    }
  }, {
    key: "getFrontalQuoteMode_CL",
    value: function getFrontalQuoteMode_CL() {
      return this.getClosetWrapper().getFrontalQuoteMode();
    }
  }, {
    key: "setDecorationMode_CL",
    value: function setDecorationMode_CL(mode) {
      this.getClosetWrapper().setDecorationMode(mode);
    }
  }, {
    key: "getDecorationMode_CL",
    value: function getDecorationMode_CL() {
      return this.getClosetWrapper().getDecorationMode();
    }
  }, {
    key: "enableAggiuntaMarker",
    value: function enableAggiuntaMarker(aggName, cod, enable, uniqueid) {
      var extras = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      this.get3D().enableAggiuntaMarker(aggName, cod, enable, uniqueid);
    }
  }, {
    key: "beginDragAndDrop",
    value: function beginDragAndDrop(element, x_wallGuid) {
      this.get3D().beginDragAndDrop(element, x_wallGuid);
    }
  }, {
    key: "getSceneBoundingAlignedMeasures",
    value: function getSceneBoundingAlignedMeasures() {
      return this.getCadWrapper().getSceneBoundingAlignedMeasures();
    }
  }, {
    key: "setActiveMatricola",
    value: function setActiveMatricola(matr) {
      this.get3D().setActiveMatricola(matr);
    }
  }, {
    key: "initDxfViewer",
    value: function initDxfViewer(canvas) {
      this.getSharedData().getCoreEngine().getDxfView().init(canvas);
    }
  }, {
    key: "setDxfJSONDraw",
    value: function setDxfJSONDraw(jsx) {
      this.getSharedData().getCoreEngine().getDxfView().setJSONDraws(jsx);
    }
  }, {
    key: "centerZoom_Dxf",
    value: function centerZoom_Dxf() {
      this.getSharedData().getCoreEngine().getDxfView().centerZoom();
    }
  }, {
    key: "zoomPlus_Dxf",
    value: function zoomPlus_Dxf() {
      this.getSharedData().getCoreEngine().getDxfView().zoomPlus();
    }
  }, {
    key: "zoomMinus_Dxf",
    value: function zoomMinus_Dxf() {
      this.getSharedData().getCoreEngine().getDxfView().zoomMinus();
    }
  }, {
    key: "setExplodeValueTypology",
    value: function setExplodeValueTypology(value) {
      this.get3D().setExplodeValueTypology(value);
    }
  }]);
  return ICad;
}();
exports.ICad = ICad;
//# sourceMappingURL=ICad.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/classes/ICad.js
// module id = 263
// module chunks = 142